import Route from '@ember/routing/route';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';

export default class VisitorsSettingsLocationI18nRoute extends Route {
  @service currentLocation;
  @service router;

  // This is a hack to get deactivate to fire
  // when the route is refreshed, when we
  // switch between locations
  beforeModel() {
    if (this.controller) {
      this.deactivate();
    }
  }

  model() {
    return this.currentLocation;
  }

  afterModel(model) {
    set(model, 'isEditingI18n', true);
  }

  deactivate() {
    super.deactivate(...arguments);
    set(this.controller, 'model.isEditingI18n', false);
  }

  @action
  backToLocation() {
    this.router.transitionTo('visitors.settings.location');
  }
}
